import axios from 'axios';
import settings from '../data/endpoints'
import {env} from '../utilities/environment'

class Paytable {


    /** @constructor */

    constructor(){
        this.paytable = '';
    }

    /**
     * Get paytable
     * @returns {Promise}
     */

    getPaytable() {

        let config = {
            headers: {
                "X-Nsft-Ngs-Company":  sevenConfig.data.company.uuid,
                "X-Nsft-Ngs-Product":  sevenConfig.data.product.cpvUuid

            }
        };

        const environment = env();
        const DC = sevenConfig.data.company.datacenter.split('_')[1];

        return axios.get(settings.paytable[environment][DC], config)
            .then( response => {
                this.paytable = response.data
            })
            .catch( error => {
                 console.warn('Failure on paytable fetch',error);

            })

    }

    /**
     * Update paytable
     * @param data {Object}
     */

    updatePaytable(data){
        this.paytable = data.paytable
    }

}

export default Paytable;




// WEBPACK FOOTER //
// paytable.js